import { render, staticRenderFns } from "./RoomRemoveDialog.vue?vue&type=template&id=71d94c4d&lang=pug&"
import script from "./RoomRemoveDialog.vue?vue&type=script&lang=js&"
export * from "./RoomRemoveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomRemoveDialog.vue"
export default component.exports